<template>
  <div class="tabTable">
    <Tabs
      :tabs="state.tabs"
      v-on:tab-changed="tabChanged"
      v-if="state.tabs.length && state.tabs.length > 1"
      :theme="theme"
      :controls="tableId"
    ></Tabs>
    <div class="data__figure data__figure--table">
      <table
        v-if="table"
        class="table table--stripped"
        :id="tableId"
        aria-live="polite"
      >
        <thead v-if="cols" class="table__thead">
          <tr class="table__headerRow">
            <th
              v-for="(col, i) in cols"
              :align="col.align"
              :width="col.width"
              class="table__th table__cell table__colHeader"
              scope="col"
            >
              <span v-if="i > 0 && table.prefix"
                >({{ table.prefix }})&nbsp;</span
              >{{ col.heading
              }}<span v-if="i > 0 && table.append"
                >&nbsp;({{ table.append }})</span
              >
            </th>
          </tr>
        </thead>
        <tbody v-if="rows">
          <tr v-for="row in rows" class="table__bodyRow">
            <component
              :is="table.firstColAsHeader && cellIndex === 0 ? 'th' : 'td'"
              v-for="(cell, cellIndex) in row"
              class="table__td table__cell"
              :scope="table.firstColAsHeader && cellIndex === 0 ? 'row' : ''"
              v-bind:style="{ textAlign: getCellAlignment(cellIndex) }"
            >
              <TrendingIndicator
                :input="normalizeCell(cell, cellIndex)"
              ></TrendingIndicator>
            </component>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script setup>
import Tabs from "./Tabs.vue";
import TrendingIndicator from "./TrendingIndicator.vue";
import { computed, onMounted, reactive } from "vue";

const props = defineProps({
  tablesData: {
    type: [Object, String],
    required: true,
  },
  tableId: {
    type: String,
    default: new Date().getTime().toString(),
  },
  theme: {
    type: String,
    default: "tabs",
  },
});

const state = reactive({
  activeTableIndex: null,
  tabs: [],
  tables:
    typeof props.tablesData === "object"
      ? props.tablesData
      : JSON.parse(props.tablesData),
});

onMounted(() => {
  if (!state.activeTableIndex)
    state.activeTableIndex = Object.keys(state.tables)[0];

  const tabs = [];
  for (const tableId in state.tables) {
    tabs.push({
      index: tableId,
      title: state.tables[tableId].title,
    });
  }
  state.tabs = tabs;
});

//computed
const table = computed(() => {
  return state.tables[state.activeTableIndex];
});
const cols = computed(() => {
  return table.value.cols;
});
const rows = computed(() => {
  return table.value.rows;
});
const dropDownMapping = computed(() => {
  //set up select field value mappings
  const map = {};
  for (let colIndex in cols.value) {
    if (cols.value[colIndex].type === "select") {
      let options = cols.value[colIndex].options;
      map[colIndex] = {};
      options.forEach((option) => (map[colIndex][option.value] = option.label));
    }
  }
  return map;
});

//methods

const tabChanged = function (index) {
  state.activeTableIndex = index;
};
const setActiveTable = function (table) {
  state.activeTableIndex = "_" + table.id;
};
const getCellAlignment = function (colIndex) {
  return cols.value[colIndex].align;
};
const normalizeCell = function (val, colIndex) {
  let colType = cols.value[colIndex].type;
  switch (colType) {
    case "select":
      return dropDownMapping.value[colIndex][val];
    default:
      return val;
  }
};
</script>

<style lang="scss">
.inlineList + .data__figure--table {
  margin-block-start: 1em;
}
.data__figureContainer {
  .inlineList {
    gap: 0.5em;
  }
}
</style>

<style scoped lang="scss">
.tabTable {
  flex: 1;
  max-width: 100%; //for tables that are wider than viewport (zoomed or mobile interface)
  overflow: auto;
}
</style>
